// Sideways lists (Stories, What to expect and step cards on narrow screens) are focusable, so they can be
// scrolled with the keyboard. That's only useful while they actually scroll: where everything fits (desktop),
// the tab stop is removed. The markup keeps tabindex="0", so without JS the lists stay scrollable.
(() => {
  const update = (element) => {
    if (element.scrollWidth > element.clientWidth + 1) {
      element.setAttribute('tabindex', '0');
    } else {
      element.removeAttribute('tabindex');
    }
  };

  const observer = new ResizeObserver((entries) => entries.forEach((entry) => update(entry.target)));

  const init = (scope) => {
    scope.querySelectorAll('[data-stay-scroll-region]').forEach((element) => {
      update(element);
      observer.observe(element);
    });
  };

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
